export default __webpack_public_path__ + "static/media/aretes-aro-grande.ee9df70f.png";